<template>
  <div>
    <b-form-group
      :label="labelTranslation ? $t(formGroupLabel) : formGroupLabel"
      class="dropdownModuleFields w-100"
      label-for="awaitType"
      label-cols-md="12"
    >
      <select-field
        v-if="selectType === 1"
        :select-model="selectModel"
        :select-options="selectOptions"
        :module-i-d="moduleID"
        :field="{}"
        :depends-on="dependsOn"
      />
      <v-select
        v-if="selectType === 2 && formGroupLabel !== 'debtiaReceipientsClient'"
        v-model="selectModel"
        :disabled="busy"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="selectOptions"
        :reduce="val => val.value"
        :clearable="false"
      >
        <template
          slot="option"
          slot-scope="option"
        >
          <div :class="assignClass(option.value) ? 'autofik' : ''">
            {{ option.label }}
          </div>
        </template>
      </v-select>
      <select-field
        v-if="selectType === 2 && formGroupLabel === 'debtiaReceipientsClient'"
        :select-model="selectModel"
        :select-options="ReceipientOptions"
        :module-i-d="moduleID"
        :field="{}"
      />
    </b-form-group>
    <template
      v-if="variable.value === 'condition_mappable'"
    >
      <conditional-mappable
        :data="variable.data"
        :assign-class="assignClass"
      />
    </template>
    <template
      v-if="variable.value === 'dato_felt' && variable.functional_value"
    >
      <b-form-group
        label="No of Days"
        class="dropdownModuleFields w-100"
        label-for="awaitType"
        label-cols-md="12"
      >
        <b-form-input
          v-model="variable.functional_value"
        />
      </b-form-group>
    </template>
    <template
      v-if="data && data.fields"
    >
      <fields
        :condition-fields="data.fields"
      />
    </template>
  </div>
</template>

<script>
import vSelect from 'vue-select'
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import SelectField from './fields/SelectField.vue'
import ConditionalMappable from './ConditionalMappable.vue'
import Fields from './fields/Fields.vue'

export default {
  components: {
    BFormGroup,
    vSelect,
    SelectField,
    BFormInput,
    ConditionalMappable,
    Fields,
  },
  props: {
    selectType: {
      type: Number,
      required: true,
    },
    filterable: {
      type: Boolean,
      required: true,
    },
    labelTranslation: {
      type: Boolean,
      required: true,
    },
    formGroupLabel: {
      type: String,
      required: true,
    },
    selectModel: {
      type: [String, Number, Array, Object],
      required: true,
      default: '',
    },
    selectOptions: {
      type: Array,
      required: true,
    },
    specialOptions: {
      type: Array,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    variable: {
      type: Object,
      required: true,
    },
    moduleID: {
      type: Number,
      required: true,
    },
    dependsOn: {
      type: [String, Number],
      default: null,
      required: false,
    },
  },
  data() {
    return {
      busy: false,
      ReceipientOptions: [
        { label: 'Creditor', value: 'debtia.receipientsClient' },
        { label: 'Debtor(s)', value: 'debtia.receipientsDebtor' },
        { label: 'Partner (s)', value: 'debtia.receipientsPartner' },
        { label: 'Court', value: 'debtia.receipientsCourt' },
        { label: 'Contact', value: 'debtia.receipientsContact' },
      ],
    }
  },
  created() {
  },
  methods: {
    assignClass(field) {
      let exists = false
      const entry = this.specialOptions.filter(e => e.name === field)
      // console.log('exists ', entry.length)
      if (entry.length > 0) {
        exists = true
      }
      return exists
    },
  },
}
</script>

    <style lang="scss">
      @import '@core/scss/vue/libs/vue-select.scss';
      .dropdownModuleFields {
        width: 50%;
      }
  .autofik {
    margin-left: -10px;
    width: 106%;
    border-radius: 4px;
    padding: 10px;
    color: white;
    background-color: #5fb3ac !important;
    box-shadow: 1px 1px 2px #d3e8e6, 0 0 15px #d3e8e6, 0 0 2px #d3e8e6;
  }
    </style>
